export default function TestDirective() {
  return {
    template: require('./test.html'),
    scope: {
      assessmentId: '=',
      test: '=',
      isEditable: '=',
      fromDialog: '=',
    },
    controller: 'TestController',
    controllerAs: 'testVM',
    bindToController: true,
    replace: true,
  };
}
